import Vue from "vue";
import "../../components/Tools/typdefs";

const state = {
  /** @type {newTicketData[]} */
  ticketList: [],
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
const getters = {
  ticketList: (state) => {
    return state.ticketList;
  },
  filteredTicketListListById: (state) => (id) => {
    return state.ticketList ? state.ticketList.filter((ticket) => {
      return ticket.SurveyInstanceId === id;
    }) : [];
  },
  activeTickets: (state) =>
    state.ticketList.filter((ticket) => ticket.isActive),

  ticketByName: (state) => (name) => {
    let result = state.ticketList.find((ticket) => ticket.Name === name);
    if (result) {
      return result;
    } else {
      return false;
    }
  },
  /**
   *
   * @param {*} state the state obj
   * @param {String} name the question name
   * @returns {boolean}
   */
  ticketDoesExist: (state) => (name) => {
    return state.ticketList.some((ticket) => ticket.Name === name);
  },
};

/** @type {import("vuex").ActionTree<typeof state>} */
const actions = {};

/** @type {import("vuex").MutationTree<typeof state>} */
const mutations = {
  clearAll(state) {
    state.ticketList = [];
  },
  addTicket(state, ticket) {
    state.ticketList.push(ticket);
  },
  updateTicket(state, ticket) {
    let updatingTicket = state.ticketList.find((t) => t.Name === ticket.Name);
    updatingTicket = ticket;
  },
  replaceTicketList(state, newTicketList) {
    state.ticketList = newTicketList;
  },
  removeInactiveTickets(state) {
    state.ticketList = state.ticketList.filter((ticket) => ticket.isActive);
  },
  updateTicketFiles(state, { Name, newlist }) {
    let updatingTicket = state.ticketList.find((t) => t.Name === Name);
    updatingTicket.FileGuidList = [...newlist];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/surveyjs/store/modules/ticketStore.js